import { Controller } from "@hotwired/stimulus"
import { showSystemToast } from "../utils/system_toast"

// Copies arbitrary text (data-share-link-url-value) to the clipboard with a
// confirmation toast. Used by the task-list share modal and by the Growth Arena
// dashboard, which copies tagged campaign links and whole draft payloads —
// hence the optional data-share-link-label-value to word the toast for
// something that isn't a URL. Defaults to "Link copied".
export default class extends Controller {
    static values = { url: String, label: String }

    copy(event) {
        event.preventDefault()
        this._copyText(this.urlValue).then((ok) => {
            if (ok) showSystemToast(this.labelValue || "Link copied")
        })
    }

    _copyText(text) {
        if (navigator.clipboard?.writeText) {
            return navigator.clipboard.writeText(text).then(() => true).catch(() => this._copyTextFallback(text))
        }
        return Promise.resolve(this._copyTextFallback(text))
    }

    _copyTextFallback(text) {
        const el = document.createElement("textarea")
        el.value = text
        el.setAttribute("readonly", "")
        el.style.position = "fixed"
        el.style.left = "-9999px"
        document.body.appendChild(el)
        el.select()
        let ok = false
        try {
            ok = document.execCommand("copy")
        } catch {
            ok = false
        }
        el.remove()
        return ok
    }
}
